import { Button } from "@/components/ui/button";
import { Text } from "@/components/ui/text";

export function StaleVersionError() {
  return (
    <div
      className="flex flex-col items-center justify-center gap-4 w-full h-full min-h-[50vh]"
      role="alert"
    >
      <Text size="4">A new version of bLIS is available.</Text>
      <Text size="2" className="text-muted-foreground">
        Please refresh to continue.
      </Text>
      <Button onPress={() => window.location.reload()} variant="outline">
        Refresh
      </Button>
    </div>
  );
}
